import AiPrompt from "../../domain/AiPrompt";
import {ResourceOwnerType} from "../../domain/ResourceOwnerType";
import {orderSystemAndOrganizationOptionGroups} from "../../utils/SelectOptionUtils";

interface AiPromptSelectOption {
    label: string;
    value: string;
}

interface AiPromptSelectOptionGroup {
    label: string;
    options: AiPromptSelectOption[];
}

function hasId(prompt: AiPrompt): prompt is AiPrompt & { id: string } {
    return !!prompt.id;
}

function toOption(prompt: AiPrompt & { id: string }): AiPromptSelectOption {
    return {
        label: prompt.name || prompt.id,
        value: prompt.id
    };
}

export function buildAiPromptSelectOptions(prompts: AiPrompt[], systemFirst: boolean): AiPromptSelectOptionGroup[] {
    const selectablePrompts = prompts.filter(hasId);
    const systemPrompts = selectablePrompts.filter(prompt => prompt.owner === ResourceOwnerType.SYSTEM);
    const organizationPrompts = selectablePrompts.filter(prompt => prompt.owner === ResourceOwnerType.ORGANIZATION);
    const organizationGroups = new Map<string, Array<AiPrompt & { id: string }>>();

    for (const prompt of organizationPrompts) {
        const organizationName = prompt.organization?.name || "Unknown";
        const group = organizationGroups.get(organizationName);

        if (group) {
            group.push(prompt);
        } else {
            organizationGroups.set(organizationName, [prompt]);
        }
    }

    const systemOptionGroups = systemPrompts.length > 0 ? [{
        label: "System",
        options: systemPrompts.map(toOption)
    }] : [];
    const organizationOptionGroups = [...organizationGroups.entries()]
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([organizationName, groupPrompts]) => ({
            label: organizationName,
            options: groupPrompts.map(toOption)
        }));

    return orderSystemAndOrganizationOptionGroups(systemOptionGroups, organizationOptionGroups, systemFirst);
}
